import Lookup from 'src/componentes/select-async';
import PontoFaixaResultadoEdit from 'src/paginas/remuneracao-variavel/pontos-faixa-resultado/edit';
import PontoFaixaResultadoList from 'src/paginas/remuneracao-variavel/pontos-faixa-resultado/view';

const PontoFaixaResultadoLookup = (props) => {
  return (
    <Lookup
      valueKey="id"
      labelKey="descricao"
      showSearch
      clearable={true}
      url="/PontoFaixaResultadoLookup"
      editComponent={PontoFaixaResultadoEdit}
      searchComponent={PontoFaixaResultadoList}
      {...props}
    />
  );
};
export default PontoFaixaResultadoLookup;
